import { application } from "./application"

import AvatarUploadController from "./avatar_upload_controller"
import ClipboardController from "./clipboard_controller"
import DiscoveryCardController from "./discovery_card_controller"
import LibraryUploadController from "./library_upload_controller"
import LibraryWebUploadController from "./library_web_upload_controller"
import JoinCodeController from "./join_code_controller"
import PhotoUploadController from "./photo_upload_controller"
import PhotoLibraryController from "./photo_library_controller"
import RoomController from "./room_controller"
import MatchMapController from "./match_map_controller"
import TimelineController from "./timeline_controller"
import SwipeDeleteController from "./swipe_delete_controller"
import ProfileController from "./profile_controller"
import PhotoFetchController from "./photo_fetch_controller"
import PhotoLightboxController from "./photo_lightbox_controller"
import CardMenuController from "./card_menu_controller"
import DropdownController from "./dropdown_controller"
import CommentsCableController from "./comments_cable_controller"
import TurboCableController from "./turbo_cable_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
import MatchPollController from "./match_poll_controller"
import PrivateSessionController from "./private_session_controller"

application.register("avatar-upload", AvatarUploadController)
application.register("clipboard", ClipboardController)
application.register("join-code", JoinCodeController)
application.register("photo-upload", PhotoUploadController)
application.register("photo-library", PhotoLibraryController)
application.register("room", RoomController)
application.register("match-map", MatchMapController)
application.register("timeline", TimelineController)
application.register("swipe-delete", SwipeDeleteController)
application.register("profile", ProfileController)
application.register("discovery-card", DiscoveryCardController)
application.register("library-upload", LibraryUploadController)
application.register("library-web-upload", LibraryWebUploadController)
application.register("photo-fetch", PhotoFetchController)
application.register("photo-lightbox", PhotoLightboxController)
application.register("card-menu", CardMenuController)
application.register("dropdown", DropdownController)
application.register("comments-cable", CommentsCableController)
application.register("turbo-cable", TurboCableController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("match-poll", MatchPollController)
application.register("private-session", PrivateSessionController)

// Bell badge: push the real unread count to the native app on every Turbo render.
// Lives in the bundle (not an inline <script>, which Hotwire Native doesn't re-run
// on navigation) so it fires reliably. No-op on web.
function postNotificationBadge() {
  const meta = document.querySelector('meta[name="unread-notifications"]')
  const count = meta ? (parseInt(meta.content, 10) || 0) : 0
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeBadge) {
    window.webkit.messageHandlers.nativeBadge.postMessage(count)
  }
}
document.addEventListener("turbo:load", postNotificationBadge)
document.addEventListener("turbo:render", postNotificationBadge)

// Tab bar visibility: tell the native app whether the current page is signed in,
// so it can hide the native tab bar on the auth (sign in / sign up) screens. The
// signed-in meta tag is only emitted on authenticated pages. No-op on web.
function postChromeState() {
  const signedIn = !!document.querySelector('meta[name="signed-in"]')
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeChrome) {
    window.webkit.messageHandlers.nativeChrome.postMessage(signedIn)
  }
}
document.addEventListener("turbo:load", postChromeState)
document.addEventListener("turbo:render", postChromeState)

// Push both states to native on EVERY way a page can appear. turbo:load/render
// cover normal in-app navigation, but some transitions — notably the sign-out
// redirect to the sign-in page — weren't firing them in the native web view, so the
// app never learned you'd signed out (tab bar stayed, other tabs kept the old
// session). turbo:frame-load catches frame renders; the immediate calls below catch
// fresh document loads (Hotwire Native cold boots re-run this bundle), which is the
// reliable path for the logout/login transition. Idempotent, so the extra calls are
// harmless on pages where the turbo events also fire.
document.addEventListener("turbo:frame-load", postNotificationBadge)
document.addEventListener("turbo:frame-load", postChromeState)

function postNativeStateNow() {
  postNotificationBadge()
  postChromeState()
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", postNativeStateNow)
} else {
  postNativeStateNow()
}
